import Vue from 'vue'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Cam from '@/components/cam/Cam.vue'
import Sidebar from '@/components/sidebar/Sidebar.vue'
import Datepicker from '@/components/datepicker/Datepicker.vue'
import Dropdown from '@/components/dropdown/Dropdown.vue'
import Loader from '@/components/loader/Loader.vue'
import Player from '@/components/player/Player.vue'
import Search from '@/components/search/Search.vue'
import { EventBus } from '@/services/EventBus'


export default {
    name: 'Alarms',
    data () {
        return {
            loading: false,
            groups: {
                views: {
                    name: 'Views',
                    open: false,
                },
                cams: {
                    name: 'Cameras',
                    placeholder: 'Find cameras',
                    search: '',
                    open: true,
                },
            },
            filters: {
                open: true,
            },
            datepicker: {
                open: false,
                start: moment().startOf('day').format(),
                stop: moment().endOf('day').format(),
            },
            searchAlarms: {
                placeholder: 'Find alarms',
                value: ''
            },
            max_count: 10,
            prevRoute: null
        }
    },
    created() {
        this.getAlarms()
    },
    mounted() {
        this.updateScroll(this.$refs.filtersScroll)
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
          vm.prevRoute = from
        })
    },
    computed: {
        ...mapGetters({
            cams: 'getCams',
            views: 'getAlarmViews',
            activeView: 'getAlarmsActiveView',
            list: 'getAlarms',
        }),
        activeAlarm() {
            return this.list.find(item => item.id === this.$route.params.alarmId) || null
        },
        selectedCamsIds() {
            let camsIds = []
            let queryCams = this.$route.query.cams ? this.$route.query.cams.split(',') : []

            if (queryCams.length) {
                camsIds = queryCams
            } else if (this.activeView) {
                this.groups.views.open = true
                camsIds = this.activeView.cams
            }

            return camsIds
        },
        alarms() {
            let camsIds = this.selectedCamsIds.length ? this.selectedCamsIds : this.cams.map(cam => cam.id)

            let result = this.list.filter(item => {
                return camsIds.indexOf(item.camId) > -1 &&
                    item.name.toLowerCase().indexOf(this.searchAlarms.value.toLowerCase().trim()) !== -1
            })

            result = _.groupBy(result, item => moment.unix(item.timestamp).startOf('day').format())

            return result
        },
        filteredCams() {
            return this.cams.filter(item => {
                return item.name.toLowerCase().indexOf(this.groups.cams.search.toLowerCase()) > -1
            })
        },
        isEmpty() {
            return _.isEmpty(this.alarms)
        },
        playerData() {
            return {
                mode: 1,
                layout: 1,
                camera_list: this.activeAlarm ? [this.activeAlarm.camId] : [],
                time: this.activeAlarm ? this.activeAlarm.time : null,
            }
        }
    },
    watch: {
        filteredCams() {
            this.updateScroll(this.$refs.filtersScroll)
        },
        views() {
            this.updateScroll(this.$refs.filtersScroll)
        },
        alarms() {
            this.updateScroll(this.$refs.alarmsScroll)
        },
        $route (to, from){
            this.$nextTick(() => {
                EventBus.$emit('views:select')
            })
        }
    },
    methods: {
        selectDate(date) {
            this.datepicker.start = date.start
            this.datepicker.stop = date.end
            this.getAlarms()
            this.datepicker.open = false
        },
        toggleGroup(type) {
            this.groups[type].open = ! this.groups[type].open
            this.updateScroll(this.$refs.filtersScroll)
        },
        updateScroll(ref) {
            if (ref) {
                this.$nextTick(() => {
                    ref.update()
                })
            }
        },
        getComment(alarm) {
            if (alarm.comment)
                return alarm.comment

            if (alarm.description)
                return alarm.description

            return Vue.i18n.translate('EVENT_' + alarm.action)
        },
        getAlarms() {
            this.loading = true;

            setTimeout(() => {
                this.$store.dispatch('getAlarms', {
                    cams:  this.cams,
                    params: {
                        start_time: this.datepicker.start,
                        stop_time: this.datepicker.stop,
                        max_count: 30,
                    }
                }).then(alarms => {
                    this.updateScroll(this.$refs.alarmsScroll)
                    this.loading = false
                })
            }, 500)
        },
        toggle(id) {
            let ids = []
            let query = null

            if (this.activeView) {
                ids = [id]
                query = { cams: ids.join(',')}
            } else {
                ids = [...this.selectedCamsIds]

                if (ids.indexOf(id) > -1) {
                    ids = ids.filter(item => item != id)
                } else {
                    ids.push(id)
                }

                query = ids.length ? { cams: ids.join(',')} : null
            }

            this.$router.replace({ name: 'alarms', query: query })
        },
        toggleAlarm(alarm) {
            let query = {
                cams: this.$route.query.cams,
                view: this.$route.query.view
            }

            this.$store.commit('setMode', 1)

            const route = {
                name: 'alarms',
                params: { alarmId: this.$route.params.alarmId === alarm.id ? null : alarm.id },
                query,
            }

            this.$router.replace(route)
        },
        goBack() {
            const paramsRoute = Object.keys(this.$route.params)
            if (paramsRoute.length) {
                this.$router.push({ ...this.$route, params: {} })
            } else if (this.prevRoute) {
                this.$router.push(this.prevRoute)
            } else {
                this.$router.push('/')
            }
        }
    },
    components: {
        Cam,
        Datepicker,
        Sidebar,
        VuePerfectScrollbar,
        Dropdown,
        Loader,
        Player,
        Search
    }
}



// WEBPACK FOOTER //
// ./src/modules/alarms/alarms.js